<template>
  <div class="page-container">
	<v-toolbar color="secondary" dark class="headline">
    	<v-toolbar-title>Tamaños</v-toolbar-title>
	</v-toolbar>
	<v-container fluid>
        <v-layout row wrap>
			<v-flex xs12 sm4 pa-1 v-for="tamanio in tamanios" :key="tamanio.id">
				<v-card>
				<v-container fluid grid-list-lg>
					<v-layout row wrap>
					<v-flex xs12>
						<div v-if="tamanio.editando!=true" class="headline tamanios-titulo" >{{tamanio.descripcion}}</div>
						<v-text-field :id="'txtTamanio' + tamanio.id" class="headline input-tamanios"  v-if="tamanio.editando==true" v-model="tamanio.descripcion"></v-text-field>
						<v-card-actions style="padding:0px;margin-top: 10px;justify-content:flex-end">
							<v-btn fab v-if="tamanio.editando==true" style="margin-right:10px!important" color="red" dark @click="cancelar(tamanio)"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
							<v-btn fab v-if="tamanio.editando==true" color="green" dark @click="aceptar(tamanio)"><v-icon class="fa-fab-icon">fa-check</v-icon></v-btn>
							<v-btn fab v-if="tamanio.editando!=true" style="margin-right:10px!important" :disabled="editando" color="red" dark @click="confirmarEliminar(tamanio)"><v-icon class="fa-fab-icon">fa-trash</v-icon></v-btn>
							<v-btn fab v-if="tamanio.editando!=true" :disabled="editando" color="blue" dark @click="setEditando(tamanio)"><v-icon class="fa-fab-icon">fa-pen</v-icon></v-btn>
						</v-card-actions>
					</v-flex>
					</v-layout>
				</v-container>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
	<v-btn color="green" :disabled="editando" dark fixed bottom right class="btn-very-large" @click="agregarNuevo()" fab>
		<v-icon>add</v-icon>
    </v-btn>
	<v-snackbar top :color="snackTamanio" v-model="snackbar">{{ mensaje }}<v-btn color="black" small fab dark @click="snackbar = false"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
    </v-snackbar>
	<v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar Tamaño</span>
        </v-card-title>
        <v-card-text>
			¿Estás seguro que querés eliminar el tamaño?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="onCancelarEliminar()">No</v-btn>
          <v-btn color="blue darken-1" dark @click="onConfirmarEliminar()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  	<div style="height:80px;width:1px;" v-if="$vuetify.breakpoint.smAndDown">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: "tamanios",
  components: {},
  data() {
    return { tamanios: [],snackbar:false,mensaje:'',snackTamanio:'success',editando:false,dialog:false,aEliminar:null};
  },
  created() {
    this.obtenerElementos();
  },
  methods: {
    obtenerElementos: function() {
		this.$http.get(this.$root.mainUrl + 'api/tamanios.php').then(result => {
			result.json().then(elem =>{
				this.tamanios = elem;
				for(let i=0;i<this.tamanios.length;i++){
					this.$set(this.tamanios[i], 'editando', false);
				}
      		});
      	}, error => {
			//   console.error(error);
			this.showMessage('Ocurrió un error al obtener los tamaños','error');
      	});
	},
	setEditando: function(tamanio){
		tamanio.descripcionBack = tamanio.descripcion;
		tamanio.editando = true;
		this.editando = true;
		this.$nextTick(() => document.getElementById('txtTamanio' + tamanio.id).focus());
	},
	cancelar: function(tamanio){
		tamanio.descripcion = tamanio.descripcionBack;
		tamanio.editando = false;
		this.editando = false;
		if (tamanio.id==null){
			this.tamanios.pop();
		}
	},
	confirmarEliminar: function(tamanio){
		this.aEliminar = tamanio;
		this.dialog = true;
	},
	onConfirmarEliminar: function(){
		this.dialog = false;
		this.eliminar(this.aEliminar);
	},
	onCancelarEliminar: function(){
		this.dialog = false;
		this.aEliminar = null;
	},
	eliminar: function(tamanio){
		tamanio.operacion = "ELIMINAR";
		this.$http.post(this.$root.mainUrl + 'api/tamanios.php',tamanio).then(result => {
			result.json().then(elem =>{
				let idx=this.getIndex(tamanio);
				this.tamanios.splice(idx, 1);
				this.snackbar = true;
				this.mensaje = "Tamaño eliminado correctamente";
				this.aEliminar = null;
			});
		}, error => {
			this.showMessage('Ocurrió un error al eliminar el tamaño','error');
			// console.error(error);
		});
	},
	aceptar: function(tamanio){
		if (tamanio.descripcion==null || tamanio.descripcion.trim()==''){
			this.showMessage('La descripción no puede estar vacía','error');
			return;
		}
		tamanio.descripcionBack = null;
		tamanio.editando = false;
		tamanio.operacion = "GUARDAR";
		this.$http.post(this.$root.mainUrl + 'api/tamanios.php',tamanio).then(result => {
			result.json().then(elem =>{
				if (elem.id!=null){
					tamanio.id=elem.id;
					this.showMessage('Tamaño creado correctamente','success');
				}
				else{
					this.showMessage('Tamaño actualizado correctamente','success');
				}
				this.editando = false;
			});
		}, error => {
			this.showMessage('Ocurrió un error al actualizar el Tamaño','error');
			// console.error(error);
		});
	},
	agregarNuevo: function(){
		this.editando = true;
		let tamanio = {editando:true,descripcion:'',id:null};
		this.tamanios.push(tamanio);
		this.$vuetify.goTo(5000);
	},
	getIndex: function(tamanio){
		for (let i=0;i<this.tamanios.length;i++){
			if (this.tamanios[i].id==tamanio.id){
				return i;
			}
		}
		return -1;
	},
	showMessage: function(message,style){
		this.snackTamanio = style;
		this.mensaje = message;
		this.snackbar = true;
	}
  }
};
</script>
<style>
.page-container{
	padding-top:60px;
}
.fa-fab-icon{
	font-size: 1.5em!important;
}
.btn-very-large{
	height: 66px!important;
	width: 66px!important;
}
.btn-very-large i{
	font-size: 3.5em!important;
}
.tamanios-titulo{
	min-height:40px;
}
.input-tamanios{
	padding-top: 0px!important;
	padding-bottom: 0px!important;
	margin-top: 0px!important;
	margin-bottom: 0px!important;
}
.input-tamanios .v-text-field__details{
	display: none;
}
</style>
